import { editCardModalStyles as styles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { css } from "styled-components";

styles.paymetricDetailsStyles = {
    paymetricIframe: {
        css: css`
            width: 100%;
            border: 0;
        `,
    },
};
